import { Col } from 'components/Col';
import { CustomCheckbox } from 'components/CustomCheckbox';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { ChangeEvent, useContext } from 'react';
import languageValues from 'utils/LanguageUtils';

export default function CienciaCoordenadorPedagogico() {
  const { state, dispatch } = useContext(ProjetosContext);
  return (
    <Row>
      <Col style={{ paddingBottom: 0 }}>
        <CustomCheckbox
          name='cienciaCordenador'
          label={languageValues.inputs.cienciaCordenador.label}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: { cienciaCordenador: event.target.checked },
            });
          }}
          checked={state.projeto.cienciaCordenador || false}
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
